import React from 'react';
import { Checkbox, FormControlLabel, Switch, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { DeleteForeverOutlined } from '@material-ui/icons';
import NavResponsiveModal, {
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/components/Navigation/NavResponsiveModal';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';
import { DangerRow, Field, FieldLabel } from './blocks';
import { isAlwaysApplied, selectedTypes, TYPE_OPTIONS, withAlwaysApply, withTypes } from './utils';

// Everything the old inline row could do — rename, set types, always-apply, delete — lives
// here now. Edits stage through `onChange`; the panel's Save button still does the writing.
const TagEditModal = ({ tag, user_id, loading, onChange, onDelete, onClose }) => (
    <NavResponsiveModal open={!!tag} onClose={onClose} maxWidth="sm" fullWidth>
        <ModalHeader title="Edit tag" onClose={onClose} />
        <ModalContent>
            {tag && (
                <>
                    <Field>
                        <FieldLabel>Tag</FieldLabel>
                        <TextField
                            variant="outlined"
                            fullWidth
                            autoFocus
                            value={tag.tag || ''}
                            onChange={(e) => onChange({ ...tag, tag: e.target.value })}
                        />
                    </Field>

                    <Field>
                        <FieldLabel>Types</FieldLabel>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            value={selectedTypes(tag)}
                            onChange={(e, options) => onChange(withTypes(tag, options))}
                            options={TYPE_OPTIONS}
                            getOptionSelected={(option, value) => option.value === value.value}
                            getOptionLabel={(option) => option.label}
                            renderTags={(options) => <span>{options.length} Type(s) selected</span>}
                            renderOption={(option, { selected }) => (
                                <li key={option.value}>
                                    <Checkbox color="primary" checked={selected} />
                                    {option.label}
                                </li>
                            )}
                            renderInput={(params) => <TextField variant="outlined" {...params} label="Types" />}
                        />
                    </Field>

                    <FormControlLabel
                        label="Always Apply"
                        control={
                            <Switch
                                color="primary"
                                checked={isAlwaysApplied(tag, user_id)}
                                onChange={(e) => onChange(withAlwaysApply(tag, user_id, e.target.checked))}
                            />
                        }
                    />

                    <DangerRow>
                        <SecondaryButton disabled={loading} onClick={() => onDelete(tag)}>
                            <DeleteForeverOutlined fontSize="small" />
                            Delete tag
                        </SecondaryButton>
                    </DangerRow>
                </>
            )}
        </ModalContent>
        <ModalActions>
            <PrimaryButton onClick={onClose}>Done</PrimaryButton>
        </ModalActions>
    </NavResponsiveModal>
);

export default TagEditModal;
